import { BaseTracker } from "../BaseTracker";
import { AuthenticatedUser } from "../../types/user";

/**
 * FacebookPixelTracker class responsible for facebook pixel events
 */
export class FacebookPixelTracker extends BaseTracker {
    constructor(user: AuthenticatedUser) {
        super(user, process.env.NEXT_PUBLIC_FB_PIXEL_ID);
    }

    protected initializeInternal() {}

    protected trackPageViewInternal() {
        const ReactPixel = require("react-facebook-pixel");
        ReactPixel.default.init(this.providerToken!);
        ReactPixel.default.pageView();
    }

    protected trackEventInternal(key: string, payload: any) {
        const ReactPixel = require("react-facebook-pixel");
        ReactPixel.default.init(this.providerToken!);
        ReactPixel.default.track(key, payload);
    }

    protected shutdownInternal() {}
}
